module.exports = __webpack_public_path__ + "static/all-the-light-we-cannot-see-6b48e631db504007eba33c2455860720.jpg";